import { render } from "./DynamicColorPicker.vue?vue&type=template&id=3c92e22c&ts=true"
import script from "./DynamicColorPicker.vue?vue&type=script&lang=ts"
export * from "./DynamicColorPicker.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicColorPicker.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c92e22c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c92e22c', __exports__)) {
    api.reload('3c92e22c', __exports__)
  }
  
  module.hot.accept("./DynamicColorPicker.vue?vue&type=template&id=3c92e22c&ts=true", () => {
    api.rerender('3c92e22c', render)
  })

}


export default __exports__